module.exports = __webpack_public_path__ + "img/logo_bg.ed8b1d6e.png";